import { takeLatest, put, delay } from 'redux-saga/effects'
import {
  HANDLE_WS_MESSAGE,
  SET_WEB_RTC_MOUNTED,
  WebSocketMessageActionType,
  RESET_CONNECTION_STATE
} from '../redux/tutorChannelReducer'

function* ResetConnectionFlow(action: WebSocketMessageActionType): Generator<any, void, any> {
  try {
    if (
      action.payload?.to === 'both' &&
      action.payload?.type === 'connection-state' &&
      (action.payload.data === 'failed' || action.payload.data === 'disconnected' || action.payload.data === 'closed')
    ) {
      yield put(SET_WEB_RTC_MOUNTED({ value: false }))
      yield put(RESET_CONNECTION_STATE())
      yield delay(1000)
      yield put(SET_WEB_RTC_MOUNTED({ value: true }))
    }
  } catch (error) {
    console.log(error)
  }
}

export default function* ResetConnectionSaga(): Generator<any, void, any> {
  yield takeLatest([HANDLE_WS_MESSAGE], ResetConnectionFlow)
}
